'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.blobSupported = blobSupported;
exports.isServer = isServer;
function blobSupported() {
    try {
        return !!new Blob();
    } catch (exception) {
        return false;
    }
}

var APP_ENV = exports.APP_ENV = typeof process !== 'undefined' && process.env.APP_ENV !== null ? process.env.APP_ENV : "browser";
var NODE_ENV = exports.NODE_ENV = typeof process !== 'undefined' && process.env.NODE_ENV !== null ? process.env.NODE_ENV : "";

function isServer() {
    return !(typeof window != 'undefined' && window.document);
}


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/featureDetection.js